module.exports = __webpack_public_path__ + "img/rock-huge-09.eae60757.png";